import type { ChatFeatureValue, ChatFeatureComponentObject, ChatFeatureComponent } from './ChatFeaturesTypes'

/** Narrows a ChatFeatureValue to ChatFeatureComponentObject ({ component?, attributes? }) */
export const isComponentObject = (value: ChatFeatureValue): value is ChatFeatureComponentObject =>
    typeof value === 'object' && value !== null && !('$$typeof' in value)

/** Narrows a ChatFeatureValue to a bare React component function */
export const isComponentFunction = (value: ChatFeatureValue): value is ChatFeatureComponent =>
    typeof value === 'function'
